var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"id":"toast","title":_vm.toastOptions.title,"variant":_vm.toastOptions.variant,"auto-hide":""}},[_vm._v("\n  "+_vm._s(_vm.toastOptions.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }